import { NgModule } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { interceptorProviders } from './interceptors/interceptor.providers';
import { GmsapidataService } from './services/gmsapidata.service';
import { CommonService } from './services/common.service';
import { GmsmenuService } from './services/gmsmenu.service'
import { from } from 'rxjs';
@NgModule({ imports: [], providers: [interceptorProviders, AuthenticationService, GmsapidataService, CommonService, GmsmenuService, provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class CoreModule { }
